import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import Moment from "moment";

import { FiMoreVertical } from "react-icons/fi";

import { Container } from "./styles";

import api from "../../services/api";

function Process({ process }: any) {
	const [showOptions, setShowOptions] = useState("hidden");

	const history = useHistory();

	const handleRemoveProcess = async (id: number) => {
		await api.delete(`/data/process&id=${id}`);

		history.push("/dashboard");
	};

	return (
		<Container>
			<td id='prop-name' title={process.proponent_name}>
				{process.proponent_name.toLowerCase()}
			</td>
			<td>{process.cpf}</td>
			<td>{Moment(process.createdAt).format("DD/MM/YYYY")}</td>
			<td>{Moment(process.createdAt).format("HH:mm")}</td>
			<td className='name-text'>
				{process.typist_one_id == null
					? "Vago"
					: process.typist_one.name.toLowerCase()}
			</td>
			<td className='name-text'>
				{process.typist_two_id === null
					? "Vago"
					: process.typist_two.name.toLowerCase()}
			</td>
			<td className='name-text'>
				{process.analist === null
					? "Vago"
					: process.analist.name.toLowerCase()}
			</td>
			<td>
				{process.status === 0
					? "Aguardando análise"
					: process.status === 1
					? "Pendente"
					: process.status === 2
					? "Em progresso"
					: process.status === 3
					? "Aprovado"
					: process.status === 4
					? "Reprovado"
					: process.status === 5
					? "Com divergência"
					: process.status === 6
					? "Aguardando digitador"
					: null}
			</td>
			<td id='options'>
				<div
					id='more_options'
					onClick={() =>
						showOptions === "hidden"
							? setShowOptions("show")
							: setShowOptions("hidden")
					}>
					<FiMoreVertical />
					<div className={`dropdown-content ${showOptions}`}>
						<button
							id='delete'
							onClick={() => handleRemoveProcess(process.id)}>
							Deletar
						</button>
						<button
							id='cancel'
							onClick={() => setShowOptions("hidden")}>
							Cancelar
						</button>
					</div>
				</div>
			</td>
		</Container>
	);
}

export default Process;
